import React from 'react'

import { Box, Typography, alpha } from "@mui/material"
import { dsColorNew } from "@palette"


export default function officeNameColumn() {

	return {
		name: 'name',
		label: 'Office',
		options: {
			setCellHeaderProps: () => ({
				sx: {
					textAlign: 'left',
					'& > span, & button': { justifyContent: 'flex-start' },
					position: 'sticky',
					top: 0,
					left: 0,
					zIndex: '150 !important',
				}
			}),
			setCellProps: (_, idx) => ({
				sx: {
					position: 'sticky',
					left: 0,
					zIndex: 3,
					minWidth: 160,
					// white like the fixed columns of BI and Pricing Environment, with the row stripes
					backgroundColor: idx % 2 === 0 ? dsColorNew.white : dsColorNew.tableRowAlt,
					boxShadow: `6px 0 8px -6px ${alpha(dsColorNew.textTitle, 0.18)}`,
				}
			}),
			customBodyRowRenderLite: officeName => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
				<Typography sx={{ fontWeight: 600, color: dsColorNew.textTitle }}>{officeName}</Typography>
			</Box>,
		}
	}
}